import { Outlet } from "react-router-dom";
import { Badge, ThemeSelector } from "@charisol-spark/ui";
import { config } from "@/config";

/**
 * Layout wrapper for the admin app's own auth pages (today: just login).
 *
 * Deliberately plain: the user app's AuthLayout sells the product (hero copy,
 * social proof, a register/login toggle); none of that applies to an internal
 * console that provisions accounts out of band. It does share the logo, the
 * card treatment and the theme selector, so sign-in looks like the same product.
 */
export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="absolute right-4 top-4">
        <ThemeSelector />
      </div>
      <div className="mb-8 flex items-center gap-3">
        <img src="/full-logo.svg" alt="Spark" className="h-16" />
        <span className="text-lg font-semibold tracking-tight">
          Spark Admin
        </span>
        {config.environmentBadge && (
          <Badge variant="warning" className="px-1.5 py-0 text-[10px]">
            {config.environmentBadge}
          </Badge>
        )}
      </div>
      <div className="w-full max-w-md rounded-2xl border border-border/50 bg-card/80 p-6 shadow-xl sm:p-8">
        <Outlet />
      </div>
    </div>
  );
}
